module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    staticClass: "site-reports-wrapper"
  }, [_c('div', {
    staticClass: "collection-sites-header"
  }, [_c('div', {
    staticClass: "collection-sites-header__primary-content"
  }, [_c('div', {
    staticClass: "collection-sites-header__header"
  }, [_vm._v("\n        Collection Sites\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "collection-sites-header__subheader--bold"
  }, [_vm._v("\n        " + _vm._s(this.collectionSites.length) + " total sites\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "collection-sites-header__subheader"
  }, [_vm._v("\n        Select a site to view logged data. Create and export reports of logged data for one or many collection sites.\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "collection-sites-header__secondary-content"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "justify-center": ""
    }
  }, [_c('v-btn', {
    staticClass: "flat-action",
    attrs: {
      "slot": "activator",
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.toggleArchived()
      }
    },
    slot: "activator"
  }, [_vm._v("\n            " + _vm._s(_vm.archivedText()) + "\n        ")]), _vm._v(" "), _c('add-collection-site')], 1)], 1)]), _vm._v(" "), _c('v-card', [_c('div', {
    staticClass: "site-reports-body"
  }, [_c('div', {
    staticClass: "site-reports-body-toolbar"
  }, [_c('div', {
    staticClass: "site-reports-body-toolbar__primary-content"
  }, [_c('div', {
    staticClass: "site-reports-toolbar-search"
  }, [_c('i', {
    staticClass: "site-reports-toolbar-search__icon material-icons"
  }, [_vm._v("search")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.controls.search),
      expression: "controls.search"
    }],
    staticClass: "site-reports-toolbar-search__input",
    attrs: {
      "placeholder": "Search collection sites"
    },
    domProps: {
      "value": (_vm.controls.search)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.controls, "search", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.selected.length > 0) ? _c('div', {
    staticClass: "site-reports-datepickers"
  }, [_c('span', {
    staticClass: "site-reports-body-toolbar__text-content"
  }, [_vm._v("Select export date range:")]), _vm._v(" "), _c('div', {
    staticClass: "site-reports-toolbar-datepicker"
  }, [_c('v-menu', {
    attrs: {
      "lazy": "",
      "close-on-content-click": false,
      "transition": "scale-transition",
      "offset-y": "",
      "full-width": "",
      "nudge-left": 0,
      "max-width": "290px"
    },
    model: {
      value: (_vm.controls.startDateModal),
      callback: function($$v) {
        _vm.$set(_vm.controls, "startDateModal", $$v)
      },
      expression: "controls.startDateModal"
    }
  }, [_c('div', {
    staticClass: "site-reports-toolbar-datepicker__activator",
    attrs: {
      "slot": "activator"
    },
    slot: "activator"
  }, [_c('span', {
    staticClass: "site-reports-toolbar-datepicker__activator-text"
  }, [_vm._v(_vm._s(_vm.startDate ? _vm.startDate : "Start Date"))]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-calendar"
  })]), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "no-title": "",
      "scrollable": "",
      "actions": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var save = ref.save;
        var cancel = ref.cancel;

        return [_c('v-card-actions', [_c('v-btn', {
          staticClass: "btn-nww",
          nativeOn: {
            "click": function($event) {
              save()
            }
          }
        }, [_vm._v("Save")]), _vm._v(" "), _c('v-btn', {
          attrs: {
            "flat": "",
            "primary": ""
          },
          nativeOn: {
            "click": function($event) {
              cancel()
            }
          }
        }, [_vm._v("Cancel")])], 1)]
      }
    }]),
    model: {
      value: (_vm.startDate),
      callback: function($$v) {
        _vm.startDate = $$v
      },
      expression: "startDate"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "site-reports-toolbar-datepicker"
  }, [_c('v-menu', {
    attrs: {
      "lazy": "",
      "close-on-content-click": false,
      "transition": "scale-transition",
      "offset-y": "",
      "full-width": "",
      "nudge-left": 0,
      "max-width": "290px"
    },
    model: {
      value: (_vm.controls.endDateModal),
      callback: function($$v) {
        _vm.$set(_vm.controls, "endDateModal", $$v)
      },
      expression: "controls.endDateModal"
    }
  }, [_c('div', {
    staticClass: "site-reports-toolbar-datepicker__activator",
    attrs: {
      "slot": "activator"
    },
    slot: "activator"
  }, [_c('span', {
    staticClass: "site-reports-toolbar-datepicker__activator-text"
  }, [_vm._v(_vm._s(_vm.endDate ? _vm.endDate : "Start Date"))]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-calendar"
  })]), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "no-title": "",
      "scrollable": "",
      "actions": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var save = ref.save;
        var cancel = ref.cancel;

        return [_c('v-card-actions', [_c('v-btn', {
          staticClass: "btn-nww",
          nativeOn: {
            "click": function($event) {
              save()
            }
          }
        }, [_vm._v("Save")]), _vm._v(" "), _c('v-btn', {
          attrs: {
            "flat": "",
            "primary": ""
          },
          nativeOn: {
            "click": function($event) {
              cancel()
            }
          }
        }, [_vm._v("Cancel")])], 1)]
      }
    }]),
    model: {
      value: (_vm.endDate),
      callback: function($$v) {
        _vm.endDate = $$v
      },
      expression: "endDate"
    }
  })], 1)], 1)]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "site-reports-body-toolbar__secondary-content"
  }, [_c('div', {
    staticClass: "site-reports-actions"
  }, [(_vm.selected.length === 1) ? _c('edit-collection-site', {
    staticClass: "site-reports-actions__action",
    attrs: {
      "collection-site": _vm.selected[0],
      "post-submit-form": _vm.postSubmitForm
    }
  }) : _vm._e(), _vm._v(" "), (_vm.selected.length === 1 && !_vm.showArchived) ? _c('v-btn', {
    staticClass: "site-reports-actions__action btn btn-nww",
    nativeOn: {
      "click": function($event) {
        _vm.archiveSite(_vm.selected[0])
      }
    }
  }, [_vm._v("\n              Archive\n              "), _c('v-icon', {
    attrs: {
      "right": "",
      "dark": ""
    }
  }, [_vm._v("archive")])], 1) : _vm._e(), _vm._v(" "), (_vm.selected.length === 1 && _vm.showArchived) ? _c('v-btn', {
    staticClass: "site-reports-actions__action btn-nww--light btn btn--raised",
    nativeOn: {
      "click": function($event) {
        _vm.unArchiveSite(_vm.selected[0])
      }
    }
  }, [_vm._v("\n              Unarchive\n              "), _c('v-icon', {
    attrs: {
      "right": "",
      "dark": ""
    }
  }, [_vm._v("unarchive")])], 1) : _vm._e()], 1), _vm._v(" "), (_vm.selected.length > 0) ? _c('div', {
    staticClass: "site-reports-toolbar-export"
  }, [_c('v-menu', {
    attrs: {
      "offset-y": "",
      "left": ""
    }
  }, [_c('div', {
    staticClass: "site-reports-toolbar-export__activator",
    attrs: {
      "slot": "activator"
    },
    slot: "activator"
  }, [_c('div', {
    staticClass: "site-reports-toolbar-export__activator-text"
  }, [_vm._v("\n                  Export\n                ")]), _vm._v(" "), _c('i', {
    staticClass: "material-icons"
  }, [_vm._v("arrow_drop_down")])]), _vm._v(" "), _c('v-list', [_c('v-list-tile', {
    on: {
      "click": _vm.exportXls
    }
  }, [_c('v-list-tile-title', [_vm._v("\n                    Export as XLS\n                  ")])], 1), _vm._v(" "), _c('v-list-tile', {
    on: {
      "click": _vm.adpotExport
    }
  }, [_c('v-list-tile-title', [_vm._v("\n                    Export for Adopt-A-Stream\n                  ")])], 1), _vm._v(" "), _c('v-list-tile', {
    on: {
      "click": _vm.storetExport
    }
  }, [_c('v-list-tile-title', [_vm._v("\n                    Export for STORET\n                  ")])], 1)], 1)], 1)], 1) : _vm._e()])]), _vm._v(" "), _c('v-card', {
    staticClass: "nww-table nww-table--left-align"
  }, [_c('v-data-table', {
    staticClass: "elevation-1",
    attrs: {
      "headers": _vm.headers,
      "items": _vm.collectionSites,
      "pagination": _vm.pagination,
      "search": _vm.controls.search,
      "select-all": "",
      "item-key": "stationName"
    },
    on: {
      "update:pagination": function($event) {
        _vm.pagination = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "headerCell",
      fn: function(props) {
        return [_c('span', {
          attrs: {
            "slot": "activator"
          },
          slot: "activator"
        }, [_vm._v("\n              " + _vm._s(props.header.text) + "\n            ")])]
      }
    }, {
      key: "items",
      fn: function(props) {
        return [_c('tr', {
          attrs: {
            "active": props.selected
          },
          on: {
            "click": function($event) {
              props.selected = !props.selected
            }
          }
        }, [_c('td', [_c('v-checkbox', {
          attrs: {
            "primary": "",
            "hide-details": "",
            "input-value": props.selected
          }
        })], 1), _vm._v(" "), _c('td', {
          staticClass: "col-long table-cell__truncate--long"
        }, [_c('router-link', {
          staticClass: "nww-table__primary-link",
          attrs: {
            "to": {
              name: 'Collection Site Data',
              params: {
                siteId: props.item['.key']
              }
            }
          }
        }, [_vm._v("\n                  " + _vm._s(props.item.stationName) + "\n                ")])], 1), _vm._v(" "), _c('td', {
          staticClass: "col-med table-cell__truncate-med"
        }, [_vm._v(_vm._s(props.item.logbookAbbv))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.lab))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.lastCollectionDate))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.lastEColiResult))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.collectionPartner))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.hucName))]), _vm._v(" "), _c('td', {
          staticClass: "col-long table-cell__truncate--long"
        }, [_vm._v(_vm._s(props.item.adoptAStreamName))]), _vm._v(" "), _c('td', {
          staticClass: "col-long table-cell__truncate--long"
        }, [_vm._v(_vm._s(props.item.aasNumber))]), _vm._v(" "), _c('td', {
          staticClass: "col-long table-cell__truncate--long"
        }, [_vm._v(_vm._s(props.item.storetName))]), _vm._v(" "), _c('td', {
          staticClass: "col-long table-cell__truncate--long"
        }, [_vm._v(_vm._s(props.item.storetId))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.numSamples))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.firstCollectionDate))]), _vm._v(" "), _c('td', {
          staticClass: "table-cell__truncate--long"
        }, [_c('a', {
          staticClass: "nww-table__primary-link",
          attrs: {
            "href": props.item.googleMapsUrl,
            "target": "_blank"
          }
        }, [_vm._v("\n                  " + _vm._s(props.item.googleMapsUrl) + "\n                ")])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.latitude))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.longitude))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.isPrivate))])])]
      }
    }]),
    model: {
      value: (_vm.selected),
      callback: function($$v) {
        _vm.selected = $$v
      },
      expression: "selected"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', [_c('v-snackbar', {
    attrs: {
      "timeout": _vm.snackbar.timeout,
      "info": true
    },
    model: {
      value: (_vm.snackbar.successVisible),
      callback: function($$v) {
        _vm.$set(_vm.snackbar, "successVisible", $$v)
      },
      expression: "snackbar.successVisible"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.snackbar.successMessage) + "\n      "), _c('v-btn', {
    attrs: {
      "dark": "",
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.snackbar.successVisible = false
      }
    }
  }, [_vm._v("Close")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6757368e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/CollectionSites.vue
// module id = 443
// module chunks = 1